<template>
  <section class="hero" v-if="headerContent">
    <div class="hero-body has-text-centered">
      <div class="container">
        <img class="pub-logo" :src="pubLogo" alt="Logo" v-if="pubLogo">
        <h1 id="header" class="title is-size-2" v-if="headerTitle">
          {{ headerTitle }}
          <h2 id="subheader" class="subtitle" v-if="headerSubtitle">
            {{ headerSubtitle }}
          </h2>
        </h1>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  computed: {
    pubLogo() {
      return this.$store.state.publication_logo;
    },
    headerTitle() {
      return this.$store.state.survey_title;
    },
    headerSubtitle() {
      return this.$store.state.survey_subtitle;
    },
    headerContent() {
      if (this.pubLogo) return true;
      if (this.headerTitle) return true;
      return false;
    },
  },
};
</script>
